// Story 17-4 — cómo salen los menús de un bot con Evolution GO
// (`whatsapp.evolution-go.interactive`). Lo usan el wizard y Settings.

export type MenuMode = 'text' | 'native';

export const MENU_MODE_LABELS: Record<MenuMode, string> = {
  text: 'Texto numerado (1️⃣ 2️⃣ 3️⃣)',
  native: 'Encuesta de WhatsApp',
};

export function MenuModeSelect({
  id,
  value,
  onChange,
  disabled,
}: {
  id: string;
  value: MenuMode;
  onChange: (mode: MenuMode) => void;
  disabled?: boolean;
}): React.ReactElement {
  return (
    <div>
      <label htmlFor={id} className="mb-1 block text-sm">
        Menús y botones
      </label>
      <select
        id={id}
        className="w-full rounded-md border border-border bg-background px-3 py-2 text-sm"
        value={value}
        disabled={disabled}
        onChange={(e) => onChange(e.target.value as MenuMode)}
      >
        <option value="text">{MENU_MODE_LABELS.text}</option>
        <option value="native">{MENU_MODE_LABELS.native}</option>
      </select>
      <p className="mt-1 text-xs text-muted-foreground">
        Con <strong>encuesta</strong>, cada menú llega como una encuesta de una sola respuesta: el
        cliente toca una opción. Evolution GO no logra mostrar botones ni listas de WhatsApp. Los
        menús de una sola opción siguen como texto.
      </p>
    </div>
  );
}
